export default {
    cognito: {
      REGION: "us-west-2",
      USER_POOL_ID: "us-west-2_4jPA50ADF",
      APP_CLIENT_ID: "482nobqfhsih1l4jk7e92f9il7",
      IDENTITY_POOL_ID: "us-west-2:98316542-b430-4c01-af66-9046a2c5966e",
      COGNITO_IP: "cognito-idp.us-west-2.amazonaws.com/us-west-2_4jPA50ADF",
      DOMAIN_URL: "qs-embed-user-pool-domain.auth.us-west-2.amazoncognito.com",
      SAML_IDP_NAME: "AzureAd",
      SSO_REDIRECT_SIGN_IN_URL: "https://dda-financial-cc-reporting-test.dshs.wa.gov",
    },
    apigateway: {
      REGION: "us-west-2",
      APIURL: "https://3x3qm5ffth.execute-api.us-west-2.amazonaws.com/Test"
    },
    dashboard: {
      NAME: "DDA-Financial-Voice-Signature"
    }
  };